import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAccessToken, loginWithSSOToken } from '../redux/actions/authActions'; // Import both actions
import { setSelectedFranchise } from '../redux/actions/franchiseActions';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { LoginComponent } from 'tutorapp-components';

export default function Loginscreen() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [startTime, setStartTime] = useState("10:00");
  const [value, setValue] = useState(['10:00', '12:00']);

  const buildVersion = process.env.REACT_APP_BUILD_VERSION ?? null;
  const forgeturl = process.env.REACT_APP_FORGETPASSWORD_URL;

  const onChange = (timeValue) => {
    setValue(timeValue);
  };

  // Access Redux state
  const userData = useSelector((state) => state.auth.userData);
  const { accessToken, error, loading } = useSelector((state) => state.auth);

  // Calling login API with user credentials
  const handleLoginApiCall = (username, password) => {
    dispatch(getAccessToken(username, password));
  };

  // 🔑 Check for SSO token in URL hash
  useEffect(() => {
    const hash = window.location.hash;
    if (hash && hash.startsWith("#token=")) {
      const token = hash.replace("#token=", "").split("&")[0];
      dispatch(loginWithSSOToken(token));
    }
  }, [dispatch]);

  // If already logged in then navigate user to franchise selection screen
  useEffect(() => {
    if (accessToken && userData?.franchise_list) {
      if (userData.wizard_completed === 0) {
        toast.error(userData.message, {
          position: "top-center",
          autoClose: 5000,
          closeOnClick: true,
          hideProgressBar: true,
          pauseOnHover: true,
          draggable: true,
          theme: "dark",
          style: { backgroundColor: "#D32F2F", color: "#fff", fontWeight: "500" }
        });
        return;
      }

      const franchiseList = userData.franchise_list;

      if (franchiseList.length === 1) {
        dispatch(setSelectedFranchise(franchiseList[0]));
        navigate('/MyAppointment');
      } else {
        navigate('/FranchiseeProfile');
      }
    }
  }, [accessToken, userData, dispatch, navigate]);

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="text-center">
        {loading ? (
          <CircularProgress style={{ color: 'black' }} />
        ) : (
          <LoginComponent
            imagePaths={imagePaths}
            onLogin={handleLoginApiCall}
            loading={loading}
            error={error}
            forgeturl={forgeturl}
          />
        )}
        <ToastContainer testID="login-toast" />
      </div>
    </div>
  );
}

// Define image paths outside component so they're not recreated each render
const imagePaths = {
  logo: './images/ic_logo.svg',
  emailIcon: './images/ic_email.svg',
  passwordIcon: './images/ic_password.svg',
  hidepasswordIcon: './images/ic_eyeclose.svg'
};
